


const API_BASE_URL = 'https://backend.maamaas.com/promotions/api/internal-ticket';

// ================= GET AUTH TOKEN =================
const getAuthToken = () => {
    const token = localStorage.getItem("authToken");

    return token;
};


// ================= GET HEADERS WITH CORS SUPPORT =================
const getHeaders = (isFormData = false) => {
    const token = getAuthToken();
    const headers = {
        'Accept': '*/*',
        'Authorization': `Bearer ${token}`,
    };

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }

    return headers;
};

// Helper function to handle API responses
const handleResponse = async (response, endpoint = '') => {

    if (!response.ok) {
        const errorText = await response.text().catch(() => "Unknown error");
        console.error(`❌ ${endpoint} Error Response:`, errorText);

        let errorMessage = `API request failed with status ${response.status}`;
        try {
            const errorJson = JSON.parse(errorText);
            console.error(`❌ ${endpoint} Error JSON:`, errorJson);
            errorMessage = errorJson.message || errorJson.error || errorMessage;
        } catch (_) {
            errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
    }

    const text = await response.text();

    try {
        return JSON.parse(text);
    } catch (_) {
        return text;
    }
};

// ================= CREATE NEW TICKET - FORM DATA APPROACH =================

// ================= CREATE NEW TICKET - JSON APPROACH (WORKING) =================
// ================= CREATE NEW TICKET - MATCHING POSTMAN =================
export const createTicket = async (ticketData, attachmentFile = null) => {


    try {
        const token = getAuthToken();
        if (!token) {
            console.error('❌ No auth token found');
            throw new Error('Authentication token not found. Please login again.');
        }

        // Clean the data
        const ticket = {
            priority: ticketData.priority,
            subject: ticketData.subject.trim(),
            raisedBy: ticketData.raisedBy.trim(),
            department: ticketData.department.toUpperCase(),
            status: 'OPEN',
            type: ticketData.issueType,
            description: ticketData.description.trim()
        };


        // Create FormData (matching Postman)
        const formData = new FormData();

        // Instead of: formData.append('ticket', JSON.stringify(ticket));
        formData.append(
            'ticket',
            new Blob([JSON.stringify(ticket)], { type: 'application/json' })
        );

        if (attachmentFile) {
            formData.append('attachment', attachmentFile);
        }



        const url = `${API_BASE_URL}/create`;

        // IMPORTANT: Don't set Content-Type header for FormData
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Authorization': `Bearer ${token}`,
                // Content-Type will be set automatically with boundary
            },
            body: formData,
            credentials: 'include',
        });



        // Get response text
        const responseText = await response.text();

        if (!response.ok) {
            let errorMessage = `Server error ${response.status}`;
            try {
                const errorJson = JSON.parse(responseText);
                errorMessage = errorJson.message || errorJson.error || errorMessage;
                console.error('❌ Error details:', errorJson);
            } catch (_) {
                errorMessage = responseText || errorMessage;
            }
            throw new Error(errorMessage);
        }

        // Parse the response
        let result;
        try {
            result = JSON.parse(responseText);
            return result;
        } catch (_) {
            return responseText;
        }

    } catch (error) {
        console.error('❌ createTicket Error:', error);
        throw error;
    }
};


// ================= CREATE TICKET WITH FORM DATA (For attachments) =================
export const createTicketWithAttachment = async (ticketData, attachmentFile) => {


    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        // Clean the data
        const ticket = {
            priority: ticketData.priority,
            subject: ticketData.subject.trim(),
            raisedBy: ticketData.raisedBy.trim(),
            department: ticketData.department.toUpperCase(),
            status: 'OPEN',
            type: ticketData.issueType,
            description: ticketData.description.trim()
        };

        const formData = new FormData();
        formData.append('ticket', JSON.stringify(ticket));

        if (attachmentFile) {
            formData.append('attachment', attachmentFile);
        }

        const url = `${API_BASE_URL}/create`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Authorization': `Bearer ${token}`,
                // Do NOT set Content-Type for FormData
            },
            body: formData,
            credentials: 'include',
        });

        const responseText = await response.text();

        if (!response.ok) {
            throw new Error(`Server error ${response.status}: ${responseText}`);
        }

        return JSON.parse(responseText);

    } catch (error) {
        console.error('❌ createTicketWithAttachment Error:', error);
        throw error;
    }
};

// ================= CREATE NEW TICKET - JSON APPROACH =================
export const createTicketJson = async (ticketData, attachmentFile = null) => {


    try {
        const token = getAuthToken();
        if (!token) {
            console.error('❌ No auth token found');
            throw new Error('Authentication token not found');
        }

        // Create ticket object matching API schema
        const ticket = {
            priority: ticketData.priority,
            subject: ticketData.subject,
            raisedBy: ticketData.raisedBy,
            department: ticketData.department.toUpperCase(),
            status: 'OPEN',
            type: ticketData.issueType,
            description: ticketData.description
        };

        const url = `${API_BASE_URL}/create`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(ticket), // Only send JSON for ticket
            credentials: 'include',
        });


        const responseText = await response.text();

        if (!response.ok) {
            console.error(`❌ Create ticket (JSON) failed with status ${response.status}`);
            let errorMessage = `Server error ${response.status}`;
            try {
                const errorJson = JSON.parse(responseText);
                console.error('❌ Error JSON:', errorJson);
                errorMessage = errorJson.message || errorJson.error || errorJson.details || responseText;
            } catch (_) {
                errorMessage = responseText || errorMessage;
            }
            throw new Error(errorMessage);
        }

        let result;
        try {
            result = JSON.parse(responseText);
        } catch (_) {
            result = responseText;
        }

        return result;

    } catch (error) {
        console.error('❌ createTicketJson Error:', error);
        console.error('❌ Error message:', error.message);
        throw error;
    }
};

// ================= UPDATE TICKET =================
export const updateTicket = async (ticketId, status = null, adminResponse = null) => {


    try {
        const token = getAuthToken();
        if (!token) {
            console.error('❌ No auth token found');
            throw new Error('Authentication token not found');
        }

        const params = new URLSearchParams();
        if (status) {
            params.append('status', status.toUpperCase());
        }
        if (adminResponse) {
            params.append('adminResponse', adminResponse);
        }

        const url = `${API_BASE_URL}/${ticketId}?${params.toString()}`;

        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Accept': '*/*',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        const result = await handleResponse(response, `PUT /${ticketId}`);
        return result;
    } catch (error) {
        console.error(`❌ updateTicket(${ticketId}) Error:`, error);
        throw error;
    }
};

// ================= GET ALL TICKETS =================
export const getAllTickets = async () => {
    try {
        const headers = getHeaders(false);
        const response = await fetch(`${API_BASE_URL}/all`, {
            method: 'GET',
            headers: headers,
            cache: "no-store",
            credentials: 'include',
        });
        const result = await handleResponse(response, 'GET /all');
        return result;
    } catch (error) {
        console.error('❌ getAllTickets Error:', error);
        throw error;
    }
};

// ================= GET TICKET SUMMARY =================
export const getTicketSummary = async () => {
    try {
        const headers = getHeaders(false);
        const response = await fetch(`${API_BASE_URL}/summary`, {
            method: 'GET',
            headers: headers,
            cache: "no-store",
            credentials: 'include',
        });
        const result = await handleResponse(response, 'GET /summary');
        return result;
    } catch (error) {
        console.error('❌ getTicketSummary Error:', error);
        throw error;
    }
};

// ================= TRANSFORM API TICKET DATA =================
export const transformTicket = (apiTicket) => {
    const transformed = {
        ticketId: String(apiTicket.ticketId || apiTicket.id),
        ticketNumber: apiTicket.ticketNumber,
        raisedBy: apiTicket.raisedBy,
        department: apiTicket.department,
        issueType: apiTicket.type || apiTicket.issueType,
        description: apiTicket.description,
        status: apiTicket.status,
        priority: apiTicket.priority,
        createdAt: apiTicket.createdAt,
        resolvedAt: apiTicket.resolvedAt,
        adminResponse: apiTicket.adminResponse,
        attachmentUrl: apiTicket.attachmentUrl,
        subject: apiTicket.subject,
    };
    return transformed;
};

export const transformTickets = (apiTickets) => {
    if (!Array.isArray(apiTickets)) {
        console.warn('⚠️ transformTickets: Expected array, got:', typeof apiTickets);
        return [];
    }
    return apiTickets.map(transformTicket);
};

// ================= GET TICKETS BY STATUS =================
export const getTicketsByStatus = async (status) => {
    try {
        const formattedStatus = status.toUpperCase();
        const headers = getHeaders(false);
        const response = await fetch(`${API_BASE_URL}/status/${formattedStatus}`, {
            method: 'GET',
            headers: headers,
            cache: "no-store",
            credentials: 'include',
        });
        const result = await handleResponse(response, `GET /status/${formattedStatus}`);
        return result;
    } catch (error) {
        console.error(`❌ getTicketsByStatus(${status}) Error:`, error);
        throw error;
    }
};


export const getTicketById = async (ticketId) => {
    try {
        const headers = getHeaders(false);
        const response = await fetch(`${API_BASE_URL}/${ticketId}`, {
            method: 'GET',
            headers: headers,
            cache: "no-store",
            credentials: 'include',
        });
        return await handleResponse(response, `GET /${ticketId}`);
    } catch (error) {
        console.error(`❌ getTicketById(${ticketId}) Error:`, error);
        throw error;
    }
};